<div id="mobileMenu">
    <!-- <a routerLink="/betting/prematch" class="menu-item" routerLinkActive="active">
        <span class="sporticon sporticon-all icon-sm"></span>
        <span class="icon-text small-text" i18n="Mobile main menu Sports@@mobileMainSports">Sportovi</span>
    </a>
    <a routerLink="/betting/live" class="menu-item" routerLinkActive="active">
        <span class="sporticon sporticon-live icon-sm"></span>
        <span class="icon-text small-text" i18n="Mobile main menu Live@@mobileMainLive">Uživo</span>
    </a> -->
    <span (click)="navigate(false)" class="menu-item" [class.active]="!isLive" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)">
      <span class="sporticon sporticon-all icon-sm"></span>
      <span class="icon-text small-text" i18n="Mobile main menu Sports@@mobileMainSports">Sportovi</span>
    </span>
    <span (click)="navigate(true)" class="menu-item" [class.active]="isLive" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)">
      <span class="sporticon sporticon-live icon-sm"></span>
      <span class="icon-text small-text" i18n="Mobile main menu Live@@mobileMainLive">Uživo</span>
    </span>
    <!-- <div class="menu-item center" id="ticketMobileMenu" (click)="openTicket()" *ngIf="(tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier"> -->
    <div class="menu-item center" id="ticketMobileMenu" (click)="openTicket()">
        <span class="icon sporticon sporticon-grid icon-lg">
            <span class="badge" *ngIf="eventsCountOnTicket > 0">{{eventsCountOnTicket}}</span>
        </span>
    </div>
    <div class="menu-item" (click)="sendPostMessage('/casino')" [class.active]="isLive" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)">
        <span class="sporticon icon-sm sporticon-casino"></span>
        <span class="icon-text small-text" i18n="Mobile main menu Casino@@mobileMainCasino">Slot</span>
    </div>
    <div class="menu-item" (click)="sendPostMessage('/virtual')" [class.active]="isLive" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)" *ngIf="!viewConfigurations.showPromotionsOnMobileMenu; else promotions">
        <span class="sporticon sporticon-esports icon-sm"></span>
        <span class="icon-text small-text" i18n="Mobile main menu Virtual@@mobileVirtual">Virtuelne</span>
    </div>
    <ng-template #promotions>
        <div class="menu-item" (click)="sendPostMessage('/virtual/spribe-game-info/aviator')" [class.active]="isLive" [class.wide]="!((tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier)">
            <span class="sporticon sporticon-esports icon-sm"></span>
            <span class="icon-text small-text" i18n="Mobile main menu Promotions@@mobilePromotions">Promocije</span>
        </div>
    </ng-template>

</div>
